import mitt from 'mitt'

const eventBus = mitt()

export default eventBus


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
